
















































































































































































































































































































import {
  CategoryCategoryDTO,
  CategoryListSubCategoryRequest,
  CategoryManagerService,
  CategorySubCategoryDTO,
  StoreHistoryManagementListOrderRequest,
  StoreManagementCategoryItemRequest,
  StoreManagementItemDTO,
  StoreManagementListItemRequest,
  StoreManagementStoreService,
} from "@/common/api";
import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import ExportItemsComponent from "@/components/admin/store/common/exportItemsComponent.vue";
import ImportItemsComponent from "@/components/admin/store/common/importItemsComponent.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import QSelect from "@/components/common/qSelect.vue";
import PaginateModel from "@/model/paginate";
import _ from "lodash";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "StoreListComponent",
  components: {
    QErrors,
    QSelect,
    ImportItemsComponent,
    ExportItemsComponent,
    QCalendar,
    QMultiSelect,
    QSearch,
    QPaginate,
    QTableHeader,
  },
})
export default class StoreListComponent extends Vue {
  public errors = [];
  public items: StoreManagementItemDTO[] = [];
  public categories: CategoryCategoryDTO[] = [];
  public subCategories: CategorySubCategoryDTO[] = [];

  public sort = "desc";

  public editingSort = false;
  public sortCategoryId = null;
  public sortSubCategoryId = null;
  public isLoadingSubCategories = false;
  public sortErrors = {};
  public originSortItems: any[] = [];
  public sortItems: StoreManagementItemDTO[] = [];
  public sortSubCategories: CategorySubCategoryDTO[] = [];

  public sales = [
    {
      id: "1",
      name: "セール対象商品",
    },
    {
      id: "0",
      name: "セール対象外商品",
    },
  ];

  public types = [
    {
      id: "consumer",
      name: "一般会員のみ",
    },
    {
      id: "business",
      name: "業者会員のみ",
    },
    {
      id: "both",
      name: "すべて",
    },
  ];

  public statuses = [
    {
      id: "release",
      name: "有効",
    },
    {
      id: "no_release",
      name: "無効",
    },
    {
      id: "hold",
      name: "保留",
    },
  ];

  public filter: StoreManagementListItemRequest = {
    sales: [],
    categoryIds: [],
    subCategoryIds: [],
    statuses: [],
    saleCode: "",
    nameOrCode: "",
    company: "",
    keyword: "",
    sort: "code",
    direction: StoreManagementListItemRequest.direction.ASC,
    perPage: 30,
    page: 1,
  };

  public sortFilter: StoreManagementCategoryItemRequest = {
    categoryId: null,
    subCategoryId: null,
  };

  public pagination = new PaginateModel({
    page: 1,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public isLoading = false;

  public isRequiredSubCategory = false;

  public changeDirection() {
    if (
      this.filter.direction === StoreManagementListItemRequest.direction.DESC
    ) {
      this.filter.direction = StoreManagementListItemRequest.direction.ASC;
    } else {
      this.filter.direction = StoreManagementListItemRequest.direction.DESC;
    }
    this.items = [];
    this.search();
  }

  @Watch("filter.categoryIds")
  public changeCategory() {
    this.getSubCategories(this.filter.categoryIds);
  }

  public scroll(event) {
    const listElm = event.target;
    if (
      !this.isLoading &&
      Math.ceil(listElm.scrollTop + listElm.clientHeight) >=
        listElm.scrollHeight &&
      this.pagination.page < this.pagination.pageCount
    ) {
      this.isLoading = true;
      this.filter.page += 1;
      this.getItems(this.filter).then((items) => {
        this.items = [...this.items, ...items];
        // eslint-disable-next-line unicorn/no-array-reduce
      });
      this.isLoading = false;
    }
  }

  public async mounted() {
    await this.getCategories();
    await this.getSubCategories();
    this.getDataFromUrl();
    this.search();
  }

  public search() {
    this.filter.page = 1;
    this.$router
      .push({
        query: {
          sort: this.filter.sort,
          direction: this.filter.direction,
          sales: this.filter.sales,
          categoryIds: this.filter.categoryIds,
          subCategoryIds: this.filter.subCategoryIds,
          statuses: this.filter.statuses,
          saleCode: this.filter.saleCode,
          nameOrCode: this.filter.nameOrCode,
          company: this.filter.company,
        } as any,
      })
      .catch(() => {
        //
      });

    this.getItems(this.filter).then((items) => {
      this.items = items;

      // eslint-disable-next-line unicorn/no-array-reduce
    });
  }

  public async getItems(query = {}) {
    const result = await StoreManagementStoreService.adminStore(query);
    this.pagination = new PaginateModel({
      page: result.data.paginator.currentPage,
      pageCount: result.data.paginator.lastPages,
      start: result.data.paginator.currentPage,
      end: result.data.paginator.lastPages,
      count: result.data.paginator.total,
    });

    this.filter.page = result.data.paginator.currentPage;

    return result.data.items;
  }

  public async getCategories() {
    const result = await CategoryManagerService.adminCategory({});
    this.categories = result.data.categories;
  }

  public async getSubCategories(category_ids: string[] = []) {
    const result = await CategoryManagerService.adminSubCategory({
      categories: category_ids,
      disabledLoadinng: true,
    } as CategoryListSubCategoryRequest);
    this.subCategories = result.data.sub_categories;
  }

  public resetSearch() {
    this.filter = {
      sales: [],
      categoryIds: [],
      subCategoryIds: [],
      statuses: [],
      saleCode: "",
      nameOrCode: "",
      company: "",
      keyword: "",
      sort: "code",
      direction: StoreManagementListItemRequest.direction.ASC,
      perPage: 30,
      page: 1,
    };

    this.search();
  }

  public sortStore(sort): void {
    if (this.filter.sort !== sort) {
      this.filter.sort = sort;
      this.filter.direction =
        StoreHistoryManagementListOrderRequest.direction.DESC;
    } else {
      this.filter.direction =
        this.filter.direction ===
        StoreHistoryManagementListOrderRequest.direction.DESC
          ? StoreHistoryManagementListOrderRequest.direction.ASC
          : StoreHistoryManagementListOrderRequest.direction.DESC;
    }

    this.search();
  }

  public showSortPopup() {
    this.editingSort = true;
  }

  public changeSortCategory() {
    this.sortSubCategoryId = null;
    this.sortSubCategories = [];
    this.getSortSubCategories();
  }

  public changeSortSubCategory() {
    if (this.sortSubCategoryId == "null") {
      this.sortSubCategoryId = null;
    }
  }

  public async getSortSubCategories() {
    if (this.sortCategoryId) {
      this.isLoadingSubCategories = true;
      const result = await CategoryManagerService.adminSubCategory({
        categories: [this.sortCategoryId],
        disabledLoadinng: true,
      } as CategoryListSubCategoryRequest);
      this.sortSubCategories = result.data.sub_categories;
      this.isRequiredSubCategory = this.sortSubCategories.length > 0;
      this.isLoadingSubCategories = false;
    }
  }

  public showSortItems() {
    this.sortFilter = {
      categoryId: this.sortCategoryId,
      subCategoryId: this.sortSubCategoryId,
    };
    this.getSortItems(this.sortFilter).then((items) => {
      this.sortItems = items;
      this.originSortItems = JSON.parse(JSON.stringify(items));
    });
  }

  public resetSort() {
    this.sortItems = [];
    this.originSortItems = [];
    this.sortCategoryId = null;
    this.sortSubCategoryId = null;
  }

  public confirmCancel() {
    if (_.isEqual(this.originSortItems, this.sortItems)) {
      this.cancelEditSort();
    } else {
      this.$modal.showCancel({
        text: this.$t("common.message.cancel_confirm"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.cancelEditSort();
        },
      });
    }
  }

  public cancelEditSort() {
    this.editingSort = false;
    this.sortErrors = {};
    this.resetSort();
  }

  public async getSortItems(options = {}) {
    const query = { categoryId: null, ...options };
    this.sortErrors = {};
    let result;
    try {
      result = await StoreManagementStoreService.adminStoreListSort(query);
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      return result.data.items;
    } else if (result.status == "400") {
      this.sortErrors = result.body.errors;
    } else {
      qNotify.error({
        text: result.body.message,
      });
    }
  }

  public async syncItems() {
    this.sortErrors = {};
    let result;
    const data = [];

    for (const value of this.sortItems) {
      data.push({ id: value.id, sort_order: value.sort_order });
    }

    try {
      result = await StoreManagementStoreService.adminStoreSync({
        items: data,
      });
      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });
        await this.showSortItems();
      }
    } catch (error) {
      result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.sortErrors = result.body.errors;
      } else {
        qNotify.error({
          text: result.body.message,
        });
      }
    }
  }

  private getDataFromUrl() {
    const currentQuery = this.$router.currentRoute.query;

    if (currentQuery.sales) {
      const sales = currentQuery.sales;
      if (typeof sales === "string") {
        this.filter.sales = [currentQuery.sales as string];
      } else if (typeof sales === "object") {
        this.filter.sales = currentQuery.sales as string[];
      }
    }

    if (currentQuery.categoryIds) {
      const categoryIds = currentQuery.categoryIds;
      if (typeof categoryIds === "string") {
        this.filter.categoryIds = [currentQuery.categoryIds as string];
      } else if (typeof categoryIds === "object") {
        this.filter.categoryIds = currentQuery.categoryIds as string[];
      }
    }

    if (currentQuery.subCategoryIds) {
      const subCategoryIds = currentQuery.subCategoryIds;
      if (typeof subCategoryIds === "string") {
        this.filter.subCategoryIds = [currentQuery.subCategoryIds as string];
      } else if (typeof subCategoryIds === "object") {
        this.filter.subCategoryIds = currentQuery.subCategoryIds as string[];
      }
    }

    if (currentQuery.statuses) {
      const statuses = currentQuery.statuses;
      if (typeof statuses === "string") {
        this.filter.statuses = [currentQuery.statuses as string];
      } else if (typeof statuses === "object") {
        this.filter.statuses = currentQuery.statuses as string[];
      }
    }

    if (currentQuery.direction) {
      this.filter.direction = String(
        currentQuery.direction,
      ) as StoreManagementListItemRequest.direction;
    }

    if (currentQuery.sort) {
      this.filter.sort = String(currentQuery.sort);
    }

    if (currentQuery.saleCode) {
      this.filter.saleCode = String(currentQuery.saleCode);
    }

    if (currentQuery.nameOrCode) {
      this.filter.nameOrCode = String(currentQuery.nameOrCode);
    }

    if (currentQuery.company) {
      this.filter.company = String(currentQuery.company);
    }

    if (currentQuery.perPage) {
      this.filter.perPage = Number(currentQuery.perPage);
    }
  }
}
